/// <amd-module name="typeahead/features/SuggestionIconSuppressor" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/typeahead/suggestionsProvider.d.ts"/>

import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {SuggestionModifier} from "typeahead/core/SuggestionModifier";

export class SuggestionIconSuppressor extends SuggestionModifier {
    private static readonly inapplicableClients: string[] = ["Flights.Search"];

    protected configuration: IStripingConfiguration[] = [{
        lobs: ["FLIGHTS"],
    }];
    protected featureName: string = "SuppressIcon";

    protected modify(suggestions: any, context: IContext) {
        suggestions.forEach((sugg): void => {
            sugg.icon = "none";
        });
    }
    protected precondition(suggestions: any, context: IContext) {
        return super.precondition(suggestions, context) &&
            SuggestionIconSuppressor.inapplicableClients.lastIndexOf(context.clientId) < 0;
    }

    // This feature is turned on in general. It is turned off off for specific client(s) to assist an investigation.
    // For details of that investigation, see:
    // https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/4368
    //
    // Should opting out of features becomes permenantly useful, it should be implemented through the suggestionPicker
    // tag. The task is tracked with https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/4192 .
}
